import { noop } from "@gr-common/common/function";
const win = import.meta.env.SSR ? globalThis : window;
const autoNamespace = /* @__PURE__ */ new Proxy(noop, {
  get: () => autoNamespace
});
if (import.meta.env.SSR) {
  win.o_global ||= autoNamespace;
  win.o_util ||= autoNamespace;
} else {
  win.o_global ||= {};
  win.o_util ||= {};
}
const { o_global, o_util } = win;
export {
  autoNamespace,
  o_global,
  o_util,
  win
};
